import { CUSTOM_MODULE } from "../services";
import fetchApi from "../utilityFunctions/customCreateApi2";

export const fetchHeaders = async ({ query = {} }) => {
  const endpoint = CUSTOM_MODULE?.GET_HEADER || "";
  return await fetchApi({ endpoint, query });
};

export const fetchHeaderValues = async ({ query = {} }) => {
  const endpoint = CUSTOM_MODULE?.GET_HEADER_VALUE || "";
  return await fetchApi({ endpoint, query });
};

export const addUpdateHeader = async ({ body = {} }) => {
  const endpoint = CUSTOM_MODULE?.ADD_UPDATE_HEADER || "";
  return await fetchApi({ endpoint, body });
};

export const addUpdateFieldValue = async ({ body = {}, query = {} }) => {
  const endpoint = CUSTOM_MODULE?.ADD_UPDATE_FIELD_VALUE || "";
  return await fetchApi({ endpoint, body, query });
};

export const fetchColumnDropdownOptions = async ({ query = {} }) => {
  const endpoint = CUSTOM_MODULE?.GET_COLUMN_DROPDOWN_OPTIONS || "";
  return await fetchApi({ endpoint, query });
};

export const addUpdateBillingOption = async ({ query = {}, body = {} }) => {
  const endpoint = CUSTOM_MODULE?.ADD_UPDATE_CUSTOM_MODULE_OPTION || "";
  return await fetchApi({ endpoint, body, query });
};

export const deleteFieldOption = async ({ params = {} }) => {
  const endpoint = CUSTOM_MODULE?.DELETE_FIELD_OPTION || "";
  return await fetchApi({ endpoint, params });
};

export const deleteColumn = async ({ params = {} }) => {
  const endpoint = CUSTOM_MODULE?.DELETE_COLUMN || "";
  return await fetchApi({ endpoint, params });
};

export const deleteRow = async ({ params = {} }) => {
  const endpoint = CUSTOM_MODULE?.DELETE_ROW || "";
  return await fetchApi({ endpoint, params });
};

export const deleteColumnOption = async ({ params = {} }) => {
  const endpoint = CUSTOM_MODULE?.DELETE_COLUMN_OPTION || "";
  return await fetchApi({ endpoint, params });
};

export const addUpdateRow = async ({ body = {}, query = {} }) => {
  const endpoint = CUSTOM_MODULE?.ADD_UPDATE_ROW || "";
  return await fetchApi({ endpoint, body, query });
};
